import { render } from "./PendingPaymentReversals.vue?vue&type=template&id=b576eb2c&scoped=true"
import script from "./PendingPaymentReversals.vue?vue&type=script&lang=js"
export * from "./PendingPaymentReversals.vue?vue&type=script&lang=js"

import "./PendingPaymentReversals.vue?vue&type=style&index=0&id=b576eb2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b576eb2c"]])

export default __exports__